export const GET_RESPONDENT_COUNT_INDUSTRY_WISE_REQUEST = "GET_RESPONDENT_COUNT_INDUSTRY_WISE_REQUEST";
export const GET_RESPONDENT_COUNT_INDUSTRY_WISE_SUCCESS = "GET_RESPONDENT_COUNT_INDUSTRY_WISE_SUCCESS";
export const GET_RESPONDENT_COUNT_INDUSTRY_WISE_FAIL = "GET_RESPONDENT_COUNT_INDUSTRY_WISE_FAIL";
export const GET_RESPONDENT_COUNT_INDUSTRY_WISE_RESET = "GET_RESPONDENT_COUNT_INDUSTRY_WISE_RESET";

export const GET_THIRD_PARTY_AUDIENCE_COUNT_SOURCE_WISE_REQUEST = "GET_THIRD_PARTY_AUDIENCE_COUNT_SOURCE_WISE_REQUEST";
export const GET_THIRD_PARTY_AUDIENCE_COUNT_SOURCE_WISE_SUCCESS = "GET_THIRD_PARTY_AUDIENCE_COUNT_SOURCE_WISE_SUCCESS";
export const GET_THIRD_PARTY_AUDIENCE_COUNT_SOURCE_WISE_FAIL = "GET_THIRD_PARTY_AUDIENCE_COUNT_SOURCE_WISE_FAIL";
export const GET_THIRD_PARTY_AUDIENCE_COUNT_SOURCE_WISE_RESET = "GET_THIRD_PARTY_AUDIENCE_COUNT_SOURCE_WISE_RESET";

export const GET_RESPONDENT_PROFILE_INDUSTRY_WISE_REQUEST = "GET_RESPONDENT_PROFILE_INDUSTRY_WISE_REQUEST";
export const GET_RESPONDENT_PROFILE_INDUSTRY_WISE_SUCCESS = "GET_RESPONDENT_PROFILE_INDUSTRY_WISE_SUCCESS";
export const GET_RESPONDENT_PROFILE_INDUSTRY_WISE_FAIL = "GET_RESPONDENT_PROFILE_INDUSTRY_WISE_FAIL";
export const GET_RESPONDENT_PROFILE_INDUSTRY_WISE_RESET = "GET_RESPONDENT_PROFILE_INDUSTRY_WISE_RESET";

export const GET_AUDIENCE_DATA_BASED_ON_FILTERS_REQUEST = "GET_AUDIENCE_DATA_BASED_ON_FILTERS_REQUEST";
export const GET_AUDIENCE_DATA_BASED_ON_FILTERS_SUCCESS = "GET_AUDIENCE_DATA_BASED_ON_FILTERS_SUCCESS";
export const GET_AUDIENCE_DATA_BASED_ON_FILTERS_FAIL = "GET_AUDIENCE_DATA_BASED_ON_FILTERS_FAIL";
export const GET_AUDIENCE_DATA_BASED_ON_FILTERS_RESET = "GET_AUDIENCE_DATA_BASED_ON_FILTERS_RESET";

